import 'react';
import 'bootstrap';

import 'jquery';

import './jquery';
import './notifications';
import './maintanance';

import { Tooltip, Toast, Popover, Carousel, Alert, Button, Collapse, Dropdown, Modal, Offcanvas, ScrollSpy, Tab } from 'bootstrap';


$(function() {
    $("[data-bs-toggle=popover]").popover();
});
